import React from "react";
import styles from './SubmitRequestCard.module.css';
import { getTimeStamp } from "../../../functions/DateFunctions";

export default function SubmitRequestCard({request,items}){

    const itemCard = (item) => {
        return (
            <div className={styles.itemCard} title={`${item.qty}x ${item.c_name}`}>
                <p className={styles.itemQty}>{item.qty}x</p>
                <p>{item.c_name}</p>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <div className={styles.code}>
                <h3>{request.code}</h3>
                <p>FAO: {request.FAOname}</p>
            </div>
            <div className={styles.address} title={`${request.addressLine1}\n${request.addressLine2}\n${request.townOrCity}\n${request.county}\n${request.postcode}\n`}>
                <p>{request.addressLine1}</p>
                {request.addressLine2? <p>{request.addressLine2}</p> : ''}
                <p>{request.townOrCity}</p>
                {request.county? <p>{request.county}</p> : ''}
                <p className={styles.last}>{request.postcode}</p>
            </div>
            <div className={styles.notes} title={request.specialItemRequests? request.specialItemRequests : "No special item requests"}>
                <p>{request.specialItemRequests? request.specialItemRequests : <span>No special item requests</span>}</p>
            </div>
            <div className={styles.notes} title={request.notes? request.notes : "No notes"}>
                <p>{request.notes? request.notes : <span>No notes</span>}</p>
            </div>
            <div className={styles.items}>
                {items.filter(item => item.quoteId === request.id).map(item => itemCard(item))}
            </div>
            <div className={styles.timeStamp} title={new Date(request.createdAt).toLocaleDateString('en-gb')}>
                {getTimeStamp(new Date(request.createdAt),false,true,true)}
            </div>
        </div>
    )
}